import { z } from "zod";
import { attachmentKindSchema } from "./enums.js";
/**
 * Invoices are photos or PDFs. The allowlist is enforced again on the server
 * against the file's magic bytes, because a client-supplied MIME type is a
 * claim, not a fact.
 */
export const ALLOWED_UPLOAD_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/heic",
];
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024; // 10 MB
export const attachmentSignSchema = z.object({
    filename: z.string().trim().min(1).max(200),
    mimeType: z.enum(ALLOWED_UPLOAD_TYPES, {
        errorMap: () => ({ message: "Upload a PDF or an image" }),
    }),
    sizeBytes: z.coerce
        .number()
        .int()
        .positive()
        .max(MAX_UPLOAD_BYTES, "Files must be under 10 MB"),
    kind: attachmentKindSchema.default("INVOICE"),
});
export const attachmentConfirmSchema = attachmentSignSchema.extend({
    key: z.string().min(1).max(300),
});
//# sourceMappingURL=attachment.js.map